import { Injectable, OnDestroy } from '@angular/core';
import { ProductConfiguration } from '../product-configuration';
import { Subscription } from 'rxjs';
import { IAddToBasketData } from '@df/session/api/basket/basket';

@Injectable()
export class ProductConfigurationBaseService implements OnDestroy {
    /**
     * Configuration service
     */
    protected configuration!: ProductConfiguration;

    /**
     * Subscriptions
     */
    protected subscriptions = new Subscription();

    /**
     * Init method to inject configuration
     */
    init(configuration: ProductConfiguration) {
        this.configuration = configuration;
    }

    /**
     * Cleanup
     */
    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    /**
     * Convert configuration to basket request
     * @returns
     */
    toBasketRequest(): IAddToBasketData {
        return {
            id: this.configuration.product$.value.id,
            qty: this.configuration.qty$.value,
            options: this.configuration.customOptionsService.getRequestOptions(this.configuration.customOptions$.value)
        };
    }
}
